module.exports = __webpack_public_path__ + "static/media/token-title-coin.fcc7da91.png";